import { render, staticRenderFns } from "./addNewItemModal.vue?vue&type=template&id=4730ccbc"
import script from "./addNewItemModal.vue?vue&type=script&lang=js"
export * from "./addNewItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports